export default function Problem() {
  return (
    <section
      id="vision"
      data-testid="problem-section"
      className="relative bg-[var(--bone)] text-[var(--ink)]"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-16 max-w-[1400px] py-24 md:py-36 lg:py-44">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-7 reveal">
            <div className="text-overline text-[var(--ink)]/55 mb-6">The world has shifted</div>
            <blockquote className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-[3.6rem] leading-[1.08] tracking-tight">
              Antisemitism is rising. Certainty is not. As Jews, we have always thought
              forward — but today we have something our grandparents did not.
              <span className="italic text-[var(--gold)]"> We have Israel.</span>
            </blockquote>
            <div className="mt-10 h-px w-24 bg-[var(--ink)]/20" />
          </div>

          <div className="lg:col-span-5 lg:pt-6 space-y-7 text-[var(--ink)]/75 reveal">
            <p className="text-base md:text-lg leading-relaxed font-light">
              Every family would love to own a home in Israel. Few can justify the millions
              of shekels, the overseas management, and the empty months that follow.
            </p>
            <p className="text-base md:text-lg leading-relaxed font-light">
              The result: a deep, unfulfilled wish for belonging, continuity and a tangible
              plan B for the next generation.
            </p>
            <p className="text-base md:text-lg leading-relaxed font-light">
              Property prices in Israel have grown more than{" "}
              <span className="text-[var(--ink)] font-medium">8% per year</span> over the
              last few years. Over the next few years, it’s predicted to grow at a much higher rate.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
